export const bchParam = {
  subUnits: 100000000,
};
